<template>
<el-form ref="form" :model="form" label-position="top">
  <el-form-item label="Atributo" :rules="[{ required: true, message: 'Campo Obligatorio' }]">
    <el-input v-model="form.description" v-on:keyup.native.enter="save()"></el-input>
  </el-form-item>
  <el-form-item label="Términos" :rules="[{ required: true, message: 'Campo Obligatorio' }]">
    <el-select
      v-model="form.terms"
      multiple
      filterable
      allow-create
      placeholder="Agrega terminos para el atributo"
      :disabled="form.description.length==0">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
  </el-form-item>
  <el-form-item class="fr">
    <el-button type="default" size="small" icon="el-icon-close" @click="reset()">Cancelar</el-button>
    <el-button 
      :type="editting ? 'warning' : 'success'" size="small" 
      @click="save()" icon="el-icon-check">
      {{ editting ? 'Actualizar' : 'Guardar' }}
    </el-button>
  </el-form-item>
</el-form>
</template>
<script>
import { mapActions } from 'vuex'
import { edit } from '@/api/administration/adminTable.js'
export default {
  data(){
    return {
      form: {
        description: '',
        terms: [],
      },
      options: [],
      editting: false
    }
  },
  created(){
    let me = this
    bus.$on('editAttribute', function(id){
      me.edit(id)
    })
  },
  methods:{
    ...mapActions(['adminTable/save']),
    save(){
      let data = {
            key: this.$route.meta.key,
            value: this.form.description,
            parent: null,
            terms: this.form.terms
          }
      this['adminTable/save'](data)
      this.reset()
    },
    edit(id){
      this.editting = true
      edit(id).then(({data}) => {
        this.form = {
          description: '',
          terms: [],
        }
        this.options = []
        this.form = {
          id: data.id,
          description: data.value_admin,
          terms: []
        }
        data.terms.forEach(element => {
          this.options.push({label: element.value_admin, value: element.id})  
          this.form.terms.push(element.id)  
        });
      }).catch(error => {console.log(error);})
    },
    reset(){
      this.form = {
        description: '',
        terms: [],
      },
      this.options = [],
      this.editting = false
    }
  }
}
</script>